








































































import Vue from 'vue'
import { catmullRom, Point } from '@/utils/spline'

type Line = {
  points: Point[]
  strokeWidth: number
  color: string
  smooth: number
  tension: number
}

export default Vue.extend({
  data() {
    return {
      lines: [] as Line[],
      points: [] as Point[],
      tension: 1,
      smooth: 10,
      strokeWidth: 5,
      color: '#82adf2',
    }
  },
  computed: {},
  methods: {
    getSmoothedPoints(points: Point[], smooth: number): Point[] {
      return points.filter((_, i) => i % smooth === 0)
    },
    getPath(points: Point[], tension: number): string {
      return catmullRom(points, tension)
    },
    clearLines() {
      this.lines = []
    },
    onPointerDown(e: PointerEvent) {
      document.addEventListener('pointermove', this.onPointerMove)
      document.addEventListener('pointerup', this.onPointerUp)
      const { offsetX, offsetY } = e
      this.points = [{ x: offsetX, y: offsetY }]
    },
    onPointerMove(e: PointerEvent) {
      const { offsetX, offsetY } = e
      this.points.push({ x: offsetX, y: offsetY })
    },
    onPointerUp() {
      document.removeEventListener('pointermove', this.onPointerMove)
      document.removeEventListener('pointerup', this.onPointerUp)
      this.lines.push({
        points: this.points,
        strokeWidth: this.strokeWidth,
        color: this.color,
        smooth: this.smooth,
        tension: this.tension,
      })
      this.points = []
    },
  },
})
